"use client";

import { useCallback } from "react";
import { useRouter } from "next/navigation";
import { Spotlight } from "@mantine/spotlight";
import type { SpotlightActionData, SpotlightFilterFunction } from "@mantine/spotlight";
import {
  TbZoomScan,
  TbLeaf,
  TbTransfer,
  TbCalendarEvent,
  TbTrees,
  TbUserCircle,
} from "@forestsync/ui";
import { detectRoute, detectType } from "@/lib/verify";

const TYPE_LABELS: Record<string, string> = {
  passport: "Carbon Passport",
  transaction: "Transaction",
  event: "Event Record",
  sink: "Carbon Sink",
  user: "Beneficiary / Developer",
};

const HINT_ACTIONS: SpotlightActionData[] = [
  {
    id: "h-passport",
    label: "Carbon Passport",
    description: "FS050DE202406…",
    leftSection: <TbLeaf size={18} />,
    disabled: true,
  },
  {
    id: "h-tx",
    label: "Transaction",
    description: "FSTX…",
    leftSection: <TbTransfer size={18} />,
    disabled: true,
  },
  {
    id: "h-event",
    label: "Event Record",
    description: "FSEVT…",
    leftSection: <TbCalendarEvent size={18} />,
    disabled: true,
  },
  {
    id: "h-sink",
    label: "Carbon Sink",
    description: "XX-XXXX",
    leftSection: <TbTrees size={18} />,
    disabled: true,
  },
  {
    id: "h-user",
    label: "Beneficiary / Developer",
    description: "8-char ID",
    leftSection: <TbUserCircle size={18} />,
    disabled: true,
  },
];

export function VerifySpotlight() {
  const router = useRouter();

  const filter = useCallback<SpotlightFilterFunction>(
    (query, _actions) => {
      const trimmed = query.trim();
      if (!trimmed) return HINT_ACTIONS;
      const route = detectRoute(trimmed);
      if (!route) return [];
      const type = detectType(trimmed);
      return [
        {
          id: "verify-navigate",
          label: `${type ? TYPE_LABELS[type] : "Record"} — ${trimmed}`,
          description: "View public record",
          leftSection: <TbZoomScan size={18} />,
          onClick: () => router.push(route),
        },
      ];
    },
    [router],
  );

  return (
    <Spotlight
      actions={[]}
      filter={filter}
      nothingFound="No matching record — check the ID format"
      searchProps={{ placeholder: "Type any ForestSync ID to verify…" }}
      scrollable
      maxHeight={360}
    />
  );
}
